import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useEffect, useState } from "react";
import DetailsTab from "./Forms/Details";
import AddressTab from "./Forms/Address";
import ContactsTab from "./Forms/Contacts";
import sidebar from "../../utils/sidebar";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import FixedSave from "../../../../components/Actions/FixedSave";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { get, post } from "../../../../utils/helpers/api";
import { useTranslation } from "react-i18next";

function CreateSupplierPage() {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id;
  const [saveLoading, setSaveLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [supplierData, setSupplierData] = useState({
    firstname: state?.supplierData?.firstname || "",
    lastname: state?.supplierData?.lastname || "",
    company_name: state?.supplierData?.company_name || "",
    email: state?.supplierData?.email || "",
    country_code: state?.supplierData?.country_code || "",
    phone_number: state?.supplierData?.phone_number || "",
    address_line_1: state?.supplierData?.address_line_1 || "",
    address_line_2: state?.supplierData?.address_line_2 || "",
    city: state?.supplierData?.city || "",
    state: state?.supplierData?.state || "",
    postal_code: state?.supplierData?.postal_code || "",
    country: state?.supplierData?.country || "",
    notes: state?.supplierData?.notes || "",
    registration_number: state?.supplierData?.registration_number || "",
    tax_id: state?.supplierData?.tax_id || "",
    nis: state?.supplierData?.nis || "",
    tax_article: state?.supplierData?.tax_article || ""
  });

  console.log('Initial supplier data:', supplierData);

  const [localContacts, setLocalContacts] = useState([]);

  useEffect(() => {
    if (id) {
      getSupplier();
    }
  }, [id]);

  const onChangeInput = (target) => {
    setSupplierData({ ...supplierData, [target.name]: target.value });
  };

  const getSupplier = async () => {
    const data = await get('/purchases/suppliers/view/' + id);
    if (data?.data) {
      setSupplierData(data.data);
    }
  };

  const addLocalContact = (data) => {
    setLocalContacts(prev => [...prev, { ...data, _tempId: Date.now() }]);
  };

  const editLocalContact = (tempId, data) => {
    setLocalContacts(prev => prev.map(c => c._tempId === tempId ? { ...data, _tempId: tempId } : c));
  };

  const deleteLocalContact = (tempId) => {
    setLocalContacts(prev => prev.filter(c => c._tempId !== tempId));
  };

  const saveNewSupplier = async () => {
    if (!supplierData.firstname && !supplierData.company_name) {
      toast.error(t('purchases.firstNameOrCompanyRequired'));
      return;
    }
    setSaveLoading(true);
    const createData = await post('/purchases/suppliers/store', { ...supplierData });
    if (!createData.success) {
      toast.error(createData.message || t('common.somethingWentWrong'));
      setSaveLoading(false);
      return;
    }
    const newId = createData.supplier.id;
    for (const contact of localContacts) {
      const { _tempId, ...contactData } = contact;
      await post('/purchases/suppliers/contacts/store/' + newId, contactData);
    }
    navigate('/purchases/suppliers');
    setSaveLoading(false);
  };

  const updateSupplier = async () => {
    setSaveLoading(true);
    const data = await post('/purchases/suppliers/update/' + id, { ...supplierData });
    if (data.success) {
      navigate('/purchases/suppliers');
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setSaveLoading(false);
  };

  return (
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader
          breadcrumb={[t('purchases.suppliers'), isNew ? t('purchases.newSupplier') : t('common.edit')]}
          onBack={() => navigate('/purchases/suppliers')}
        />

        <div className="subheader-page-content scrollable">
          <Nav tabs>
            <NavItem>
              <NavLink active={activeTab === 1} onClick={() => setActiveTab(1)}>{t('common.description')}</NavLink>
            </NavItem>
            <NavItem>
              <NavLink active={activeTab === 2} onClick={() => setActiveTab(2)}>{t('common.address')}</NavLink>
            </NavItem>
            <NavItem>
              <NavLink active={activeTab === 3} onClick={() => setActiveTab(3)}>{t('crm.contactInformation')}</NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId={1}>
              <DetailsTab supplierData={supplierData} onChangeInput={onChangeInput} />
            </TabPane>
            <TabPane tabId={2}>
              <AddressTab supplierData={supplierData} onChangeInput={onChangeInput} />
            </TabPane>
            <TabPane tabId={3}>
              <ContactsTab
                isNew={isNew}
                supplierData={supplierData}
                localContacts={localContacts}
                onLocalAdd={addLocalContact}
                onLocalEdit={editLocalContact}
                onLocalDelete={deleteLocalContact}
                onSaved={getSupplier}
              />
            </TabPane>
          </TabContent>
        </div>
      </div>

      <FixedSave
        onSave={isNew ? saveNewSupplier : updateSupplier}
        loading={saveLoading}
        disabled={saveLoading}
      />
    </SidebarLayout>
  );
}

export default CreateSupplierPage;
